import { render } from "./IdentifyPaymentTrsxnsView.vue?vue&type=template&id=1cedf1f0"
import script from "./IdentifyPaymentTrsxnsView.vue?vue&type=script&lang=js"
export * from "./IdentifyPaymentTrsxnsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__